import {
  Checkbox,
  FormControlLabel,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { TwoWeekText } from '../constants';
import { useStyles } from './index.styles';
import DropDownIcon from '../../../assets/icons/drop.png';
import filterIcon from '../../../assets/icons/filtericon.png';
import { HomePageTable1 } from '../../Stock/constants';
import { ToolTipElement } from '../../Stock/ToolTipElement';

/**
 * @type {React.FC<import("../../../typings").TOptionTradeFilterBarProps>}
 * @returns
 */
const OptionTradeFilterBar = ({ pageState, setPageState }) => {
  const { isMobile, loading } = useSelector(
    (state) => state.appReducer
  );
  const classes = useStyles();
  const {
    toggleOnlyAtm,
    toggleNoSpreads,
    toggleRemoveWeeks,
    toggleTable1Dropdown,
  } = pageState;

  const filterOptions = [
    {
      label: 'ATM & OTM Options',
      checked: toggleOnlyAtm,
      onChangeHandler: () =>
        setPageState((prev) => ({
          ...prev,
          toggleOnlyAtm: !toggleOnlyAtm,
        })),
    },
    {
      label: 'No Spreads',
      checked: toggleNoSpreads,
      onChangeHandler: () =>
        setPageState((prev) => ({
          ...prev,
          toggleNoSpreads: !toggleNoSpreads,
        })),
    },
    {
      label: `${TwoWeekText}`,
      checked: toggleRemoveWeeks,
      onChangeHandler: () =>
        setPageState((prev) => ({
          ...prev,
          toggleRemoveWeeks: !toggleRemoveWeeks,
        })),
    },
  ];

  const tooltipClickHandler = () => {
    setPageState({
      ...pageState,
      currentType: 'hometable1',
      showModal: true,
    });
  };
  return (
    <div
      className={
        isMobile ? classes.filterTextMobile : classes.filterText
      }
    >
      <div
        className={isMobile ? classes.mobileWrapper : classes.wrapper}
      >
        {isMobile && (
          <div
            className={classes.dropDown}
            onClick={() =>
              setPageState({
                ...pageState,
                toggleTable1Dropdown: !toggleTable1Dropdown,
              })
            }
          >
            <img
              className={classes.dropDownImgClass}
              src={DropDownIcon}
              alt='test'
            />
          </div>
        )}
        <div
          className={
            isMobile
              ? classes.headingStyleMobile
              : classes.headingStyle
          }
        >
          Top Options Trade
        </div>
        <div
          className={
            isMobile ? classes.filterIcon : classes.filterIconMobile
          }
          onClick={() =>
            setPageState({
              ...pageState,
              currentFilterType: 'table1',
              showMobileFilterModal: true,
            })
          }
        >
          <img
            className={classes.dropDownImgClass}
            src={filterIcon}
            alt='test'
          />
        </div>
        <div style={{ marginTop: '2.2%', marginLeft: '1%' }}>
          <ToolTipElement
            text={HomePageTable1}
            clickHandler={tooltipClickHandler}
          />
        </div>
      </div>
      <div className={classes.textOpera}>
        <em>Opra Data Delayed by 15 mins</em>{' '}
      </div>

      <div
        className={
          isMobile
            ? classes.checkboxWrapperMobile
            : classes.checkboxWrapper
        }
      >
        {filterOptions.map((option, index) => (
          <FormControlLabel
            key={index}
            style={{ height: '20px', fontWeight: 'bold' }}
            control={
              <Checkbox
                disabled={loading}
                sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: 8.6,
                    boxShadow: '0.1px 0.1px 0.5px 0.1px',
                  },
                }}
                checked={option.checked}
                onChange={() => option.onChangeHandler()}
              />
            }
            label={
              <Typography
                className={
                  isMobile
                    ? classes.mobileTextLabel
                    : classes.textLabel
                }
              >
                {option.label}
              </Typography>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default OptionTradeFilterBar;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/OptionTradeFilterBar/index.jsx